import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconDocumentWord = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconDocumentWord"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M2.88 0A2.88 2.88 0 0 0 0 2.88v18.24A2.88 2.88 0 0 0 2.88 24h18.24A2.88 2.88 0 0 0 24 21.12V2.88A2.88 2.88 0 0 0 21.12 0zm6.098 16.58a.96.96 0 0 0 .542.131.95.95 0 0 0 .567-.145 1 1 0 0 0 .304-.343q.067-.12.105-.251l1.518-4.92 1.518 4.92q.027.066.106.25c.076.131.18.244.304.33a.92.92 0 0 0 .567.16.96.96 0 0 0 .555-.133.8.8 0 0 0 .277-.29q.069-.121.12-.251l2.481-7.2a1.9 1.9 0 0 0 .093-.6.54.54 0 0 0-.159-.396 1.6 1.6 0 0 0-.554-.304 1.45 1.45 0 0 0-.62-.105.6.6 0 0 0-.396.211c-.121.162-.21.346-.264.541L14.4 13.108l-1.396-4.871a9 9 0 0 0-.12-.264.8.8 0 0 0-.284-.317 1.03 1.03 0 0 0-.607-.145 1 1 0 0 0-.555.132.86.86 0 0 0-.29.303q-.07.148-.12.304l-1.39 4.83-1.65-4.896a1.5 1.5 0 0 0-.277-.541.52.52 0 0 0-.383-.185c-.204 0-.407.035-.6.106a1.05 1.05 0 0 0-.686.462c-.076.27-.058.56.053.818l2.481 7.2q.027.066.106.24a.86.86 0 0 0 .296.295"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconDocumentWord);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
